export default __webpack_public_path__ + "static/media/running_trail.61430947.jpg";